import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "alerts" }
const _hoisted_2 = ["onClick"]

import "./Alerts.scss";
import {useAlertsStore} from "@/stores/alertsStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'Alerts',
  setup(__props) {

let alertsStore = useAlertsStore();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(alertsStore).alerts, (alert) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["alert", `alert--${alert.type}`]),
        key: alert.id,
        onClick: _withModifiers(($event: any) => (_unref(alertsStore).remove(alert)), ["prevent"])
      }, _toDisplayString(alert.message), 11, _hoisted_2))
    }), 128))
  ]))
}
}

})